export const ActionTypes={
    SET_PRODUCTS: "SET_PRODUCTS",
    SELECTED_PRODUCTS: "SELECTED_PRODUCTS",
    REMOVE_SELECTED_PRODUCTS: "REMOVE_SELECTED_PRODUCTS",
    LEAVES_LIST: "LEAVES_LIST",
    PRODUCTS_ADDED_TO_CART:"PRODUCTS_ADDED_TO_CART",
    REMOVE_ITEM_FROM_CART:"REMOVE_ITEM_FROM_CART",
};